import { Box } from '@mui/material';
import { muiStyles } from './muiStyles';
import PricingIntelligence from './PricingIntelligence';
import StageHistory from './StageHistory';

const Sidebar = () => {
  return (
    <Box sx={muiStyles.root}>
      <PricingIntelligence />
      <StageHistory />
      {/* <RecentActivity /> */}
    </Box>
  );
};

export default Sidebar;
